import React from 'react'
import  { Col, Row } from "reactstrap";

// labels
import {
    DELETE,
    LB_DATE, LB_HOUR, LB_PEOPLE, LB_SERVICE,
    LB_WL_CONFIRMED, LB_WL_DETAILS, LB_WL_GUEST,
    LB_WL_PROCESSING, LB_WL_REJECTED, LB_WL_RESERVA, LB_WL_SERVICE
} from "../../i18n/i18n";
import {hasPermission} from "../../buttons/buttonsActions";

const ListHeader = ({type='WISHLIST'}) => {

    if(type == 'WISHLIST')
        return <Row className={'mb-middle-m'}>
            <Col className={'fex-center'}>{LB_WL_RESERVA}</Col>
            <Col className={'fex-center'}>{LB_WL_GUEST}</Col>
            <Col className={'fex-center'}>{LB_WL_SERVICE}</Col>
            <Col className={'fex-center'}>{LB_WL_CONFIRMED}</Col>
            <Col className={'fex-center'}>{LB_WL_PROCESSING}</Col>
            <Col className={'fex-center'}>{LB_WL_REJECTED}</Col>
            <Col className={'fex-center'} sm={1}>{LB_WL_DETAILS}</Col>
        </Row>


    return <Row className={'mb-middle-m'}>
        <Col sm={1} className={'fex-center'}>{LB_WL_RESERVA}</Col>
        <Col sm={3} className={'fex-center'}>{LB_WL_GUEST}</Col>
        <Col sm={2} className={'fex-center'}>{LB_SERVICE}</Col>
        <Col sm={1} className={'fex-center'}>{LB_DATE}</Col>
        <Col sm={1} className={'fex-center'}>{LB_HOUR}</Col>
        <Col sm={1} className={'fex-center'}>{LB_PEOPLE}</Col>
        <Col sm={3}  className={'fex-space-evenly'}>
            <i className={'fa fa-times-circle'} aria-hidden='true' type='reject' />
            <i className={'fa fa-info-circle'} aria-hidden='true' type='process' />
            <i className={'fa fa-check-circle'} aria-hidden='true' type='confirm' />
        </Col>
    </Row>
}

export default ListHeader